<template>
    <div>

        <vue-headful title="Corrective Actions :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-wrench"></i> Corrective Actions</li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4" v-if="canManage">
            <b-nav-item :active="curTab === 'list'" @click="curTab = 'list'">
                Corrective Actions
            </b-nav-item>
            <b-nav-item :active="curTab === 'settings'" @click="curTab = 'settings'">
                Settings
            </b-nav-item>
        </ul>

        <div v-show="curTab == 'list'">
            <saved-filter-title :filterKey="'correctiveActionFilters'" />

            <div class="card">
                <div class="card-body">
                    <corrective-action-list ref="correctiveActionIndexList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
                </div>
            </div>
        </div>

        <template v-if="canManage">
            <b-card v-show="curTab == 'settings'">
                <strong slot="header">
                    Email Reminder Settings
                </strong>

                <div class="alert alert-warning">
                    If enabled, MeritEHS will send a weekly reminder on Monday morning at 7 AM for all Open Corrective Actions. Each assigned user or other assignee will only receive 1 email on Monday with all their assigned Open Corrective Actions.
                </div>

                <div class="form-horizontal">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right text-muted">Send Weekly Reminders:</label>
                        <div class="col-md-6">
                            <b-form-checkbox v-model="enable_action_reminders" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-md-right text-muted">Enable Completed Action Email: <i class="fa fa-question-circle" title="If enabled, upon completing an open corrective action, all other assignees and the creator will be notified."></i></label>
                        <div class="col-md-6">
                            <b-form-checkbox v-model="enable_completed_action_email" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                        </div>
                    </div>

                    <div class="form-group row" v-if="enable_completed_action_email === 1">
                        <label class="col-md-3 col-form-label text-md-right text-muted">
                            Additional Email Recipients:
                        </label>
                        <div class="col-md-9">
                            <template v-if="loading_settings">
                                <i class="fa fa-spinner fa-spin"></i> Loading
                            </template>
                            <template v-else>
                                <email-alert-recipients ref="actionRecips" assetType="CorrectiveAction" :startingRecipients="email_alert_recipients" :formErrors="errors"></email-alert-recipients>
                                <div class="mt-2">
                                    <a href="javascript:void(0)" v-on:click="$refs.actionRecips.addRecipient()" title="Add Email Recipient"><i class="fa fa-plus"></i> Add Email Recipient</a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="saveEmailSettings()" :disabled="saving">
                    <template v-if="saving">Updating <i class="fa fa-spin fa-spinner"></i></template>
                    <template v-else>Update Email Settings</template>
                </button>
            </b-card>
        </template>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                filter_id: this.$route.query.filter_id,
                loading_settings: true,
                curTab: 'list',
                enable_action_reminders: 0,
                enable_completed_action_email: 0,
                saving: false,
                email_alert_recipients: [],
                errors: {},
            }
        },

        computed: {
            appliedFilter(){
                return this.$store.state.appliedFilter;
            },

            canManage(){
                //Check for admin
                return this.$store.state.user.is_admin;
            },
        },

        methods: {
            setUpdateFilter(){
                //Set it
                this.$store.commit('setUpdateFilter', true);
            },

            setDeleteFilter(){
                //Set it
                this.$store.commit('setDeleteFilter', true);
            },

            removeFilter(){
                //Clear the filters?
                this.$refs.correctiveActionIndexList.filtersCleared();

                //Set it
                this.$router.push('/correctiveactions');
            },

            getEmailSettings(){
                //Get the settings
                //this.loading = true;

                //Send it
                this.$http
                .get('corrective-actions/settings')
                .then(response => {
                    //Get the stuff
                    this.enable_action_reminders = response.data.enable_action_reminders;
                    this.enable_completed_action_email = response.data.enable_completed_action_email;
                    this.email_alert_recipients = response.data.email_alert_recipients;
                })
                .catch(error => {
                    //Alert the user
                    this.$toastr.error(error.response.data, 'Failed to Save Action Reminder Email Settings');
                })
                .then(response => {
                    //Flag
                    this.loading_settings = false;
                });
            },

            saveEmailSettings(){
                //Helper
                this.saving = true;
                this.errors = {};

                //Build the Paylod
                var payload = {
                    enable_action_reminders: this.enable_action_reminders,
                    enable_completed_action_email: this.enable_completed_action_email,
                    email_alert_recipients: this.$refs.actionRecips.getRecipients(),
                };

                //Send it
                this.$http
                .post('corrective-actions/settings', payload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Corrective Action Settings Saved');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Save Corrective Action Settings');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;

                    //Set the error
                    this.$refs.actionRecips.setErrors(this.errors);
                });
            }
        },

        mounted(){
            //Check Admin
            if(this.canManage)
            {
                this.getEmailSettings();
            }

            //Focus on the SEarch Input
            this.$refs.correctiveActionIndexList.$refs.correctiveActionsTable.$refs.genericFilter.focus();
        },
    }
</script>
